<template>
  <div :class="[b(), className]" :style="styleSizeName" class="bigScreenBasicSelect">
    <div :ref="id" :style="styleChartName">
      <el-select
          ref="selectRef"
          v-if="!prop.showTree"
          v-model="selInitValue"
          :style="{
          width: '100%',
          '--sel-input-font-size': (option?.fontSize || 14) + 'px',
          '--sel-input-font-color': (option.color || '#00eaff'),
        }"
          :clearable="!closeClear"
          filterable
          size="small"
          class="reset-class"
          popper-class="VisualSelects"
          @change="handleSelectChange"
          :placeholder="option.placeholder || '请选择'"
      >
        <!-- 跳转进入场景下，不能清空下拉框，避免误操作，设计关闭配置closeClear -->
        <el-option
            v-for="item in options"
            :key="item.value"
            :style="{
            'font-size': (option?.fontSize || 14) + 'px',
            'color': (option.color || '#00eaff'),
          }"
            :label="item.label"
            :value="item.value"
        />
      </el-select>
      <el-tree-select
          v-else
          ref="selectRef"
          :props="treeProp"
          v-model="selInitValue"
          :data="treeOptions"
          filterable
          :default-expand-all="option.treeExpand"
          check-strictly
          :style="{
          width: '100%',
          '--sel-input-font-size': (option?.fontSize || 14) + 'px',
          '--sel-input-font-color': (option.color || '#00eaff'),
        }"
          :clearable="!closeClear"
          :placeholder="option.placeholder || '请选择'"
          size="small"
          class="reset-class"
          popper-class="VisualSelects VisualTreeSelects"
          @change="handleSelectChange"
      />
    </div>
  </div>
</template>

<script>
import {DEFAULT_VALUE_TYPR} from "@/option/common/dict";
import { ElMessage } from "element-plus";
export default {
  name: "basicSelect",
  components: {},
  props: {},
  data() {
    return {
      selInitValue: "",
      options: [
        {
          label: "选项一",
          value: 1,
        },
        {
          label: "选项二",
          value: 2,
        },
        {
          label: "选项三",
          value: 3,
        },
      ],
      borderRadius: "0px",
    };
  },
  computed: {
    treeOptions() {
      return this.dataChart.map((item) => {
        return {
          ...item,
        };
      });
    },
    treeProp() {
      return {
        label: this.dcode,
        value: this.dcode,
      }
    },
    closeClear() {
      return this.option.closeClear
    }
  },
  watch: {},
  created() {
  },
  mounted() {
    // // 默认打开下拉框
    // if (this.option.openSelect) {
    //   this.$nextTick(() => {
    //     this.$refs['selectRef'].focus()
    //   })
    // }
  },
  destroyed() {
  },
  methods: {
    initDefaultValue() {
      const {defaultValue, defaultValueCode} = this.option
      const {dimensions} = this.prop
      if (defaultValue && defaultValue === 'pageParam') {
        dimensions.forEach(item => {
          let _c = defaultValueCode || item.fieldKey
          if (this.$route.query && this.$route.query[_c]) {
            this.selInitValue = this.$route.query[_c]
            this.setLinkData(this.dcode, this.selInitValue)
          }
        })
      }
    },
    updateChart() {
      if (!this.isDataCenter) {
        return
      }
      const {categories = [], series = []} = this.getDimentionOption();
      this.options = (categories || []).map((item) => {
        return {
          label: item,
          value: item,
        };
      });
      // 需要清空默认值的情况
      if (this.option.defaultValue === 'clear') {
        this.selInitValue = ''
        this.setLinkData(this.dcode, DEFAULT_VALUE_TYPR.CLEAR)
      } else {
        this.initDefaultValue()
        if (!this.selInitValue) {
          if (this.option.selectOne) {
            if (categories.length === 1) {
              this.selInitValue = categories[0]
            }
          } else {
            this.selInitValue = categories[0]
          }
          if (this.selInitValue) {
            this.setLinkData(this.dcode, this.selInitValue)
          }
        }
      }
    },
    findTreeItem(tree, key, value) {
      for (const node of tree) {
        if (node[key] === value) return node;
        if (node.children && node.children.length) {
          const found = this.findTreeItem(node.children, key, value);
          if (found) return found;
        }
      }
      return null;
    },
    handleSelectChange(value) {
      this.setLinkData(this.dcode, value)
    },
  },
};
</script>

<style lang="scss">
.VisualSelects {
  .el-tree {
    --el-tree-node-hover-bg-color: rgba(38, 39, 39, 30%) !important;
    //--el-tree-node-hover-bg-color: transparent !important;
  }
}

.bigScreenBasicSelect {
  .el-input.is-focus {
    input.el-input__inner::placeholder {
      color: rgb(0 234 255 / 40%);
    }
  }
}

.reset-class {
  background: none !important;
  border: none;

  input.el-input__inner {
    background: none;
    border: none;
    padding: 0;
    color: var(--sel-input-font-color);
    font-size: var(--sel-input-font-size);
    font-weight: 400;
    text-align: center;
  }

  input.el-input__inner::placeholder {
    color: var(--sel-input-font-color);
    font-size: var(--sel-input-font-size);
    font-weight: 400;
  }

  i.el-select__caret {
    font-size: 12px !important;
    width: 16px;
    line-height: 40px;
    color: #00eaff !important;
  }

  .el-input__wrapper {
    background: none !important;
    box-shadow: none !important;
  }
}

.el-popper.is-light.VisualSelects {
  background: none;
}

div.VisualSelects {
  background: radial-gradient(88.85% 68.47% at 50% 0%, #95ecff80 0%, #00a3ff40 24.48%, #0066ff26 61.98%, #0047ff00 100%), linear-gradient(180deg, #7cd0ff66 0%, #0047ff66 100%), #002b5c55;
  color: #00eaff;
  border: 1px solid #01c2ff;
  border-radius: 4px;

  .el-popper.is-light {
    background: none;
  }

  .popper__arrow {
    display: none;
  }

  .el-scrollbar {
    position: relative;
    min-height: 148px;
    height: auto;
    overflow: inherit;
    overflow-x: hidden;
    content-visibility: auto;
  }

  .el-select-height {
    width: 1px;
    position: absolute;
    top: 0;
    left: 0;
  }

  .el-select-dropdown__list {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .el-select-dropdown__wrap {
    height: 0;
  }

  .el-select-dropdown__item {
    padding: 3px 14px;
    text-align: center;
    color: #00eaff;
    background: none !important;
  }

  .el-select-dropdown__item.selected {
    background: none !important;
    color: #00eaff;
  }

  .el-select-dropdown__item.hover {
    background: none !important;
    color: #00eaff;
  }

  .el-input__wrapper {
    background: none !important;
    box-shadow: none !important;
  }

  .el-popper__arrow {
    display: none !important;
  }
}

div.VisualTreeSelects {
  .el-select-dropdown__item {
    text-align: left;
  }

  .el-tree-node__expand-icon {
    margin-top: 6px;
  }
}
</style>